import {getStepTypesService} from '@/services/stepTypesService'
import {GetStepTypesRequest, GetStepTypesResponse} from '@/types/StepTypes'

export function getStepTypesUseCase(params: GetStepTypesRequest, signal?: AbortSignal): Promise<GetStepTypesResponse> {
  return getStepTypesService(params, signal)
}
